import React from 'react'
import { Link } from 'react-router-dom'

function Hero2() {
    const scrollTop =()=>window.scrollTo({top:0,behavior:"smooth"})
  return (
    <>
     <section className="hero-area">
        <div id="particles-js" />
        <div className="verticale-social">
          <ul className="vertical-media">
            <li><a href="http://facebook.com/digihunktech">Facebook</a></li>
            <li><a href="http://instagram.com/digihunk/">Instagram</a></li>
             <li><a href="https://twitter.com/digihunktech">Twitter</a></li>
            <li><a href="https://www.linkedin.com/company/digihunktech/">Linkedin</a></li>
          </ul>
        </div>
        <div className="hero-wrapper">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7
              ">
                <div className="hero-content layout2">
                  <h1>Your Reliable <span>Digital Partner</span> </h1>
                  <p>DigiHunk Originates Stellar Designs and Anchor Technology to make your digital presence stand out of the crowd seamlessly.</p>
                  <div className="buttons">
                    <div className="cmn-btn">
                      <div className="line-1" />
                      <div className="line-2" />
                      <Link to={`${process.env.PUBLIC_URL}/contact`} onClick={scrollTop}>Contact Our Experts</Link>
                    </div>
                   
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="hero-img wow animate fadeInUp">
                  <img src={process.env.PUBLIC_URL + '/img/about.svg'} alt="" height={450} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>   
    </>
  )
}

export default Hero2